// extracted by mini-css-extract-plugin
export var background = "container-module--background--fd4b1";
export var content = "container-module--content--146eb";
export var contentNoCut = "container-module--contentNoCut--9b411";
export var cut = "container-module--cut--3b7a7";
export var cutShadow = "container-module--cutShadow--5d0cc";
export var goBack = "container-module--goBack--78a1b";
export var htmlContent = "container-module--htmlContent--08f75";
export var mainBackground = "container-module--mainBackground--50282";
export var scrollableHtmlContent = "container-module--scrollableHtmlContent--08512";
export var title = "container-module--title--8831e";
export var topBar = "container-module--topBar--cb360";